// ABOUTME: class-variance-authority variants of CHeading — visual level and weight
// ABOUTME: Kept apart from the component so CHeading.tsx exports only the component

import { cva } from "class-variance-authority"

export const headingVariants = cva("font-bold tracking-tight", {
  variants: {
    level: {
      page: "text-[26px] md:text-2xl mb-4 md:mb-10 max-md:w-[75%]",
      h1: "text-xl md:text-2xl",
      h2: "text-lg md:text-xl",
      h3: "text-base md:text-lg",
      h4: "text-sm md:text-base",
      h5: "text-sm",
      h6: "text-xs",
    },
    weight: {
      normal: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold",
    },
  },
  defaultVariants: {
    level: "h1",
    weight: "bold",
  },
})
